import { FormControl, FormField, FormItem, FormLabel } from "../form/Form";
import { useFormContext } from "react-hook-form";
import { Switch } from "./Switch";

const FormSwitch = ({ name, label }) => {
  const { control } = useFormContext();

  return (
    <div>
      <FormField
        control={control}
        name={name}
        render={({ field }) => (
          <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3 shadow-sm">
            <div className="space-y-0.5">
              <FormLabel>{label}</FormLabel>
            </div>
            <FormControl>
              <Switch checked={field.value} onCheckedChange={field.onChange} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
};

export default FormSwitch;
